// extracted by mini-css-extract-plugin
export default {"wrapper":"SignIn_wrapper__LY6PK","image":"SignIn_image__VgUoY","content":"SignIn_content__VVrkI"};